import { fork, put, call, all, select, takeEvery } from 'redux-saga/effects'

import * as actions from './preloader.actions'
import * as selectors from './preloader.selectors'
import { buildUri, buildUriMedia, buildModelsUri } from './preloader.helpers'

let registry = {}
/**
 *  Start the preload of a bunch of assets
 *  @param   {object}  action  Redux action
 */
function* startPreload(action) {
  const { isCurrent, sceneId, toPreload } = action.data
  const preLoader = yield select(selectors.getPreloader)
  const toLoad = Object.keys(toPreload).reduce((acc, assetId) => {
    const oldAsset = preLoader.preloaded[assetId]
    const asset = toPreload[assetId]
    if (!oldAsset || oldAsset.url !== asset.url) {
      acc[assetId] = asset
    }
    return acc
  }, {})

  yield fork(loadFiles, toLoad, isCurrent, sceneId)
}

/**
 *  Load all files marked as loadable.
 */
function* loadFiles(assets, isCurrent, sceneId) {
  let requestsArray = []
  for (let assetId in assets) {
    if (!registry[assetId]) {
      //first Time we load the asset
      const asset = assets[assetId]
      const { url } = asset
      let type = assets[assetId].type
      const uri =
        type === 'media'
          ? buildUriMedia(url)
          : type === 'models'
          ? buildModelsUri(url)
          : buildUri(url)
      const requestConf = { mode: 'cors' }
      const request = new Request(uri, requestConf)
      registry[assetId] = uri //register the element
      try {
        requestsArray.push(call(fetchAsset, request, assetId, uri))
      } catch (e) {
        yield put(actions.notifyProgress(assetId, ''))
      }
    }
  }

  yield all(requestsArray)

  const [, tutorial, lang] = window.location.pathname.split('/')
  if (tutorial !== 'tutorial') {
    if (isCurrent) {
      yield put(actions.finishCurrentScenePreload(sceneId))
    } else {
      yield put(actions.finishNextScenesPreload(sceneId))
    }
  }
}

function* fetchAsset(request, assetId, uri) {
  yield call(fetch, request)
  yield put(actions.notifyProgress(assetId, uri))
}

/**
 *  Preloader sagas entrypoint.
 */
export function* sagas() {
  yield takeEvery(actions.PRELOAD_START, startPreload)
}
